"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldTooltipCoreInputs = void 0;
class EmeraldTooltipCoreInputs {
    constructor() {
        this.id = Math.random().toString(36).substr(2, 9);
        this.closeOnTriggerHidden = false;
        this.closeOnOutsideClick = true;
        this.trigger = 'hover';
        this.delayHide = 0;
        this.delayShow = 0;
        this.defaultVisible = false;
        this.followCursor = false;
        this.interactive = false;
        this.placement = 'auto';
        this.visible = false;
        this.persistent = false;
    }
}
exports.EmeraldTooltipCoreInputs = EmeraldTooltipCoreInputs;
//# sourceMappingURL=tooltip.inputs.js.map